function updateQuantityButtons(input) {
  const value = input.valueAsNumber;
  const stepper = input.closest('[data-quantity-stepper]');
  stepper.querySelector('[data-quantity-step="-1"]').disabled = input.disabled || value <= Number(input.min);
  stepper.querySelector('[data-quantity-step="1"]').disabled = input.disabled || (input.max !== '' && value >= Number(input.max));
}

document.addEventListener('click', function (event) {
  const button = event.target.closest('#cartForm [data-quantity-step]');
  if (!button || button.disabled) return;

  const input = button.closest('[data-quantity-stepper]').querySelector('input');
  const previousValue = input.value;
  input.stepUp(Number(button.dataset.quantityStep));
  if (input.value !== previousValue) {
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

['input', 'change'].forEach(function (eventName) {
  document.addEventListener(eventName, function (event) {
    if (event.target.matches('#cartForm [data-quantity-stepper] input')) {
      updateQuantityButtons(event.target);
    }
  });
});

function initializeQuantity() {
  const input = document.querySelector('#cartForm [data-quantity-stepper] input');
  if (input) updateQuantityButtons(input);
}

document.addEventListener('product:update:complete', initializeQuantity);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeQuantity);
else initializeQuantity();
